export default class MediaNotFoundError extends Error {}
